import logoBuilderBR from './logoBuilder.br';
import logoBuilderMX from './logoBuilder.mx';
import logoBuilderCL from './logoBuilder.cl';
import logoBuilderCO from './logoBuilder.co';

const logoBuilder = {
  BR: logoBuilderBR,
  MX: logoBuilderMX,
  CL: logoBuilderCL,
  CO: logoBuilderCO,

};

export default logoBuilder;
